// 管理员管理
import http from "@/jslibs/axios/http";

// 新增管理员
export const add = (data) => http.post("/v1/cms/AdminUser", data);

// 修改管理员
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/AdminUser/${uuid}`, data);

// 删除管理员
export const del = ({ uuid }) => http.delete(`/v1/cms/AdminUser/${uuid}`);

// 管理员详情
export const detail = ({ uuid, ...data }) => http.get(`/v1/cms/AdminUser/${uuid}`, data);

// 管理员列表
export const list = (data) => http.get("/v1/cms/AdminUser", data);
